import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "b-admin-layout h-ph-50 h-flex-center h-flex-dir-column" }
const _hoisted_2 = { class: "h-mt-50" }
const _hoisted_3 = { class: "h-font-18 h-fw-400 h-width-400 h-text-center" }
const _hoisted_4 = { class: "b-notification__item h-flex h-flex-justify-start h-flex-center h-mt-20" }
const _hoisted_5 = { class: "h-font-18" }
const _hoisted_6 = { class: "h-mt-40" }
const _hoisted_7 = { class: "b-upload-avatar__txt h-font-16 h-fw-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('ONBOARDING.NOTIFICATIONS.TITLE')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('ONBOARDING.NOTIFICATIONS.SUBTITLE')), 1),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_FwIcon, {
            class: "h-flex-center h-pointer h-mh-30",
            icon: notification.icon,
            size: "20",
            color: "#27dbbd"
          }, null, 8, ["icon"]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(notification.title)), 1)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_FwButton, {
        borderRadiusType: "tiny-border",
        disabled: true,
        onClick: _ctx.goNextPage
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ONBOARDING.NOTIFICATIONS.BUTTON.ENABLE')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", {
      class: "h-mt-20 h-flex h-flex-center h-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goNextPage && _ctx.goNextPage(...args)))
    }, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(`ONBOARDING.AVATAR.LATER`)), 1),
      _createVNode(_component_FwIcon, {
        class: "h-flex-center h-ml-20 h-pointer",
        icon: "arrow-right",
        size: "10",
        color: "rgba(33,63,107,.3)"
      })
    ])
  ]))
}